import React from "react";

import Select, { Props as SelectProps } from "react-select";

import components from "./CustomComponents";
import useCustomStyles from "./hooks/useCustomStyles";
import useGetMultiSelectProps from "./hooks/useGetMultiSelectProps";
import {
  CustomComponentProps,
  CustomLogicProps,
  Option,
  OptionGroup,
  Options,
  Value
} from "./types";

export type Props = SelectProps<Option, true, OptionGroup> &
  CustomComponentProps &
  CustomLogicProps & {
    value?: Value;
    options: Options;
    onChange: (value: Value, actionMeta?: any) => void;
  };

export default function MultiSelectDropdown({
  name,
  options,
  value,
  onChange,
  isSearchable = false,
  isClearable = false,
  isDisabled = false,
  closeMenuOnSelect = false,
  hideSelectedOptions = false,
  backspaceRemovesValue = false,
  renderNoOptionsMessage,
  fixedValues = [],
  listHeader = "",
  withSelectAll = false,
  dataNoTranslateOption,
  dataNoTranslateListHeader,
  ariaLabel,
  maxMultiValueLabels = 5,
  disableAllSelected = false,
  ...otherProps
}: Props) {
  const selectStyles = useCustomStyles();
  const multiSelectRef = React.useRef(null);

  const customProps = useGetMultiSelectProps({
    options,
    value,
    onChange,
    withSelectAll,
    isDisabled,
    fixedValues,
    multiSelectRef,
    maxMultiValueLabels,
    disableAllSelected
  });

  return (
    <div ref={multiSelectRef}>
      <Select
        {...otherProps}
        {...customProps}
        name={name}
        isMulti
        styles={selectStyles}
        closeMenuOnSelect={closeMenuOnSelect}
        hideSelectedOptions={hideSelectedOptions}
        backspaceRemovesValue={backspaceRemovesValue}
        isSearchable={isSearchable}
        isClearable={isClearable}
        isDisabled={isDisabled}
        noOptionsMessage={renderNoOptionsMessage}
        // @ts-expect-error: https://github.com/JedWatson/react-select/issues/4804
        components={components}
        // The following props will all cause type warnings due to the above issue,
        // but react-select will pass them all to the custom components within
        // the `selectProps` prop. It is currently impossible to type this correctly.
        dataNoTranslateOption={dataNoTranslateOption}
        dataNoTranslateListHeader={dataNoTranslateListHeader}
        listHeader={listHeader}
        fixedValues={fixedValues}
        ariaLabel={ariaLabel}
        maxMultiValueLabels={maxMultiValueLabels}
      />
    </div>
  );
}
